import styled, { AnyStyledComponent } from 'styled-components';
import { TemplateTypes } from './template.types';
import Colors from '../../style/universal.color';

const {
  mlbBlack,
  mlbWhite
} = Colors;

interface ContentProps {
  dark: boolean;
  teamColor1: string;
  type: TemplateTypes;
}

export const Wrapper: AnyStyledComponent = styled.div`
    border-bottom: ${ ({ dark }: { dark: boolean; }) => `solid 1px ${dark ? mlbWhite : mlbBlack}` };
`;

// styling has a hiearchy. For example below if there is a team theme (teamColor1) selected it will override the color designated by boolean dark theme
// @ts-ignore
export const Content: AnyStyledComponent = styled.span`
    color: ${ ({ dark }: ContentProps) => dark ? 'white' : 'black' };
    color: ${ ({ teamColor1 }: ContentProps) => teamColor1 ? teamColor1 : '' };
    font-style: ${ ({ type }) => type === TemplateTypes.INFO ? 'italic' : 'normal' };
`;
